import {
  UPDATE_FILES_LIST,
  UPDATE_ROOT_FOLDER,
  UPDATE_METADATA,
  ADD_FILE_TO_SAVE,
  SAVE_FOLDER_STRUCTURE,
  // SAVE_FOLDER_STRUCTURE_SUCCESS,
  SAVE_FOLDER_STRUCTURE_FAILURE,
  SEND_NOTIFICATION_FOLDER,
  SAVE_FILES_IDS
} from '../constants/upload-folder-types'
import BunkeyAPI from "../api/BunkeyAPI";
import {
  sendNotification,
} from "../utils";

export const updateFilesList = (fileList) => {
  return dispatch => {
    dispatch({
      type: UPDATE_FILES_LIST,
      payload: {
        fileList: fileList,
      }
    })
  }
}

export const updateRootFolder = (rootFolder) => {
  return dispatch => {
    dispatch({
      type: UPDATE_ROOT_FOLDER,
      payload: {
          rootFolder: rootFolder
      }
    })
  }
}

export const updateMetadata = (metadata) => {
  return dispatch => {
    dispatch({
      type: UPDATE_METADATA,
      payload: metadata
    })
  }
}

export const addFileToSave = (file) => {
  return dispatch => {
    dispatch({
      type: ADD_FILE_TO_SAVE,
      payload: file
    })
  }
}

export const saveFolderStructure = (workclient, folders, tags, intl, folder, createdDate, dueDate, emails, sessionId, fileToSave) => {
  const uuidSession = sessionId ? sessionId : null;
  return (dispatch) => {
    dispatch({ type: SAVE_FOLDER_STRUCTURE });
    BunkeyAPI({
      url: `/clients/${workclient}/upload-files-directory/${folder}`,
      method: "POST",
      data: [
        {
          files: folders
        },
        {
          tags: tags
        },
        {
          configuration: {
            createdDate : createdDate,
            dueDate : dueDate,
            emails: emails
          }
        },
        uuidSession
      ]
    })
      .then((resp) => {
        dispatch({
          type: SAVE_FILES_IDS,
          payload: {
            data: resp.data ? resp.data : null,
            asset: fileToSave
          }
          /* payload: {
            data: asset,
            headers: resp.headers,
            folder: folder,
          }, */
        });
        // dispatch({
        //   type: SAVE_FOLDER_STRUCTURE_SUCCESS,
        //   payload: {

        //   }
        //   /* payload: {
        //     data: asset,
        //     headers: resp.headers,
        //     folder: folder,
        //   }, */
        // });
        // sendNotification(
        //   "success",
        //   intl,
        //   intl.formatMessage({ id: "uploaded_correctly" })
        // );
      })
      .catch((err) => {
        dispatch({
          type: SAVE_FOLDER_STRUCTURE_FAILURE,
          payload: err,
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "error_upload" })}`
        );
      });
  };
};

export const sendNotificationsaveFolder = (intl, emails) => {
  return (dispatch) => {
    dispatch({ type: SEND_NOTIFICATION_FOLDER });
    BunkeyAPI({
      url: `/clients/send-email/new-assets`,
      method: "POST",
      data: [
        ...emails
      ]
    })
      .then((resp) => {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "uploaded_correctly" })
        );
      })
      .catch((err) => {
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "error_upload" })}`
        );
      });
  };
};
  